module.exports = new __parcel__URL__("faq_expanded_zh-cn.22f9e74c.webp").toString();